/** Reads the app's active theme color (--color-main-primary is an "R, G, B" triplet on :root). */
function readThemeColor(cssVar: string, fallback: string): string {
  if (typeof document === 'undefined' || typeof getComputedStyle !== 'function') return fallback;
  const raw = getComputedStyle(document.documentElement).getPropertyValue(cssVar).trim();
  return raw ? `rgb(${raw})` : fallback;
}

const PRIMARY_COLOR = readThemeColor('--color-main-primary', '#5063b6');

/** NEMT Bootstrap theme palette (public/assets/css/bootstrap.min.css). */
export const THEME_COLORS = {
  primary: PRIMARY_COLOR,
  primaryHover: '#4455a5',
  blue: '#4a81d4',
  blueHover: '#2d67be',
  navy: '#323a46',
  body: '#323a46',
  muted: '#98a6ad',
  success: '#1abc9c',
  info: '#4fc6e1',
  warning: '#f7b84b',
  danger: '#f1556c',
  light: '#f1f5f7'
};

export const CHART_COLORS = [
  PRIMARY_COLOR,
  '#1abc9c',
  '#4a81d4',
  '#f7b84b',
  '#4fc6e1',
  '#f1556c',
  '#675aa9',
  '#98a6ad'
];

export function colorByIndex(index: number, colors: string[] = CHART_COLORS): string {
  return colors[index % colors.length];
}

export interface ChartItem {
  label: string;
  value: number;
  color?: string;
}

export function prepareChartData(items: any[], valueKey = 'value', labelKey = 'label', maxItems = 8): ChartItem[] {
  return [...(items || [])]
    .map((item) => ({
      label: item[labelKey] || item.name || 'Unknown',
      value: Number(item[valueKey]) || 0,
      color: item.color
    }))
    .filter((item) => item.value > 0)
    .sort((a, b) => b.value - a.value)
    .slice(0, maxItems);
}

/** Keeps zero values — used for KPI stat bar charts. */
export function prepareStatsData(items: any[], valueKey = 'value', labelKey = 'label', maxItems = 12): ChartItem[] {
  return [...(items || [])]
    .map((item) => ({
      label: item[labelKey] || item.name || 'Unknown',
      value: Number(item[valueKey]) || 0,
      color: item.color
    }))
    .slice(0, maxItems);
}

export function formatChartValue(value: number, valueFormatter?: (v: number) => string): string {
  if (valueFormatter) return valueFormatter(value);
  return Number(value).toLocaleString();
}
